export const points = [
  {
    x: 1,
    y: 0.5,
    offsetX: 0.15,
    offsetY: 0.35,
    values: [0, 3],
  },
  {
    x: 2,
    y: 0.5,
    offsetX: 0.15,
    offsetY: 0.35,
    values: [3, 6],
  },
  {
    x: 3,
    y: 0.5,
    offsetX: 0.15,
    offsetY: 0.35,
    values: [6, 9],
  },
  {
    x: 4,
    y: 0.5,
    offsetX: 0.15,
    offsetY: 0.35,
    values: [9, 12],
  },
  {
    x: 5,
    y: 0.5,
    offsetX: 0.15,
    offsetY: 0.35,
    values: [12, 15],
  },
  {
    x: 6,
    y: 0.5,
    offsetX: 0.15,
    offsetY: 0.35,
    values: [15, 18],
  },
  {
    x: 7,
    y: 0.5,
    offsetX: 0.15,
    offsetY: 0.35,
    values: [18, 21],
  },
  {
    x: 8,
    y: 0.5,
    offsetX: 0.15,
    offsetY: 0.35,
    values: [21, 24],
  },
  {
    x: 9,
    y: 0.5,
    offsetX: 0.15,
    offsetY: 0.35,
    values: [24, 27],
  },
  {
    x: 10,
    y: 0.5,
    offsetX: 0.15,
    offsetY: 0.35,
    values: [27, 30],
  },
  {
    x: 11,
    y: 0.5,
    offsetX: 0.15,
    offsetY: 0.35,
    values: [30, 33],
  },
  {
    x: 12,
    y: 0.5,
    offsetX: 0.15,
    offsetY: 0.35,
    values: [33, 36],
  },
  {
    x: 1,
    y: 1,
    offsetX: 0.15,
    offsetY: 0.15,
    values: [0, 2, 3],
  },
  {
    x: 1.5,
    y: 1,
    offsetX: 0.35,
    offsetY: 0.15,
    values: [2, 3],
  },
  {
    x: 2,
    y: 1,
    offsetX: 0.15,
    offsetY: 0.15,
    values: [2, 3, 5, 6],
  },
  {
    x: 2.5,
    y: 1,
    offsetX: 0.35,
    offsetY: 0.15,
    values: [5, 6],
  },
  {
    x: 3,
    y: 1,
    offsetX: 0.15,
    offsetY: 0.15,
    values: [5, 6, 8, 9],
  },
  {
    x: 3.5,
    y: 1,
    offsetX: 0.35,
    offsetY: 0.15,
    values: [8, 9],
  },
  {
    x: 4,
    y: 1,
    offsetX: 0.15,
    offsetY: 0.15,
    values: [8, 9, 11, 12],
  },
  {
    x: 4.5,
    y: 1,
    offsetX: 0.35,
    offsetY: 0.15,
    values: [11, 12],
  },
  {
    x: 5,
    y: 1,
    offsetX: 0.15,
    offsetY: 0.15,
    values: [11, 12, 14, 15],
  },
  {
    x: 5.5,
    y: 1,
    offsetX: 0.35,
    offsetY: 0.15,
    values: [14, 15],
  },
  {
    x: 6,
    y: 1,
    offsetX: 0.15,
    offsetY: 0.15,
    values: [14, 15, 17, 18],
  },
  {
    x: 6.5,
    y: 1,
    offsetX: 0.35,
    offsetY: 0.15,
    values: [17, 18],
  },
  {
    x: 7,
    y: 1,
    offsetX: 0.15,
    offsetY: 0.15,
    values: [17, 18, 20, 21],
  },
  {
    x: 7.5,
    y: 1,
    offsetX: 0.35,
    offsetY: 0.15,
    values: [20, 21],
  },
  {
    x: 8,
    y: 1,
    offsetX: 0.15,
    offsetY: 0.15,
    values: [20, 21, 23, 24],
  },
  {
    x: 8.5,
    y: 1,
    offsetX: 0.35,
    offsetY: 0.15,
    values: [23, 24],
  },
  {
    x: 9,
    y: 1,
    offsetX: 0.15,
    offsetY: 0.15,
    values: [23, 24, 26, 27],
  },
  {
    x: 9.5,
    y: 1,
    offsetX: 0.35,
    offsetY: 0.15,
    values: [26, 27],
  },
  {
    x: 10,
    y: 1,
    offsetX: 0.15,
    offsetY: 0.15,
    values: [26, 27, 29, 30],
  },
  {
    x: 10.5,
    y: 1,
    offsetX: 0.35,
    offsetY: 0.15,
    values: [29, 30],
  },
  {
    x: 11,
    y: 1,
    offsetX: 0.15,
    offsetY: 0.15,
    values: [29, 30, 32, 33],
  },
  {
    x: 11.5,
    y: 1,
    offsetX: 0.35,
    offsetY: 0.15,
    values: [32, 33],
  },
  {
    x: 12,
    y: 1,
    offsetX: 0.15,
    offsetY: 0.15,
    values: [32, 33, 35, 36],
  },
  {
    x: 12.5,
    y: 1,
    offsetX: 0.5,
    offsetY: 0.15,
    values: [35, 36],
  },
  {
    x: 1,
    y: 1.5,
    offsetX: 0.15,
    offsetY: 0.35,
    values: [0, 2],
  },
  {
    x: 2,
    y: 1.5,
    offsetX: 0.15,
    offsetY: 0.35,
    values: [2, 5],
  },
  {
    x: 3,
    y: 1.5,
    offsetX: 0.15,
    offsetY: 0.35,
    values: [5, 8],
  },
  {
    x: 4,
    y: 1.5,
    offsetX: 0.15,
    offsetY: 0.35,
    values: [8, 11],
  },
  {
    x: 5,
    y: 1.5,
    offsetX: 0.15,
    offsetY: 0.35,
    values: [11, 14],
  },
  {
    x: 6,
    y: 1.5,
    offsetX: 0.15,
    offsetY: 0.35,
    values: [14, 17],
  },
  {
    x: 7,
    y: 1.5,
    offsetX: 0.15,
    offsetY: 0.35,
    values: [17, 20],
  },
  {
    x: 8,
    y: 1.5,
    offsetX: 0.15,
    offsetY: 0.35,
    values: [20, 23],
  },
  {
    x: 9,
    y: 1.5,
    offsetX: 0.15,
    offsetY: 0.35,
    values: [23, 26],
  },
  {
    x: 10,
    y: 1.5,
    offsetX: 0.15,
    offsetY: 0.35,
    values: [26, 29],
  },
  {
    x: 11,
    y: 1.5,
    offsetX: 0.15,
    offsetY: 0.35,
    values: [29, 32],
  },
  {
    x: 12,
    y: 1.5,
    offsetX: 0.15,
    offsetY: 0.35,
    values: [32, 35],
  },
  {
    x: 1,
    y: 2,
    offsetX: 0.15,
    offsetY: 0.15,
    values: [0, 1, 2],
  },
  {
    x: 1.5,
    y: 2,
    offsetX: 0.35,
    offsetY: 0.15,
    values: [1, 2],
  },
  {
    x: 2,
    y: 2,
    offsetX: 0.15,
    offsetY: 0.15,
    values: [1, 2, 4, 5],
  },
  {
    x: 2.5,
    y: 2,
    offsetX: 0.35,
    offsetY: 0.15,
    values: [4, 5],
  },
  {
    x: 3,
    y: 2,
    offsetX: 0.15,
    offsetY: 0.15,
    values: [4, 5, 7, 8],
  },
  {
    x: 3.5,
    y: 2,
    offsetX: 0.35,
    offsetY: 0.15,
    values: [7, 8],
  },
  {
    x: 4,
    y: 2,
    offsetX: 0.15,
    offsetY: 0.15,
    values: [7, 8, 10, 11],
  },
  {
    x: 4.5,
    y: 2,
    offsetX: 0.35,
    offsetY: 0.15,
    values: [10, 11],
  },
  {
    x: 5,
    y: 2,
    offsetX: 0.15,
    offsetY: 0.15,
    values: [10, 11, 13, 14],
  },
  {
    x: 5.5,
    y: 2,
    offsetX: 0.35,
    offsetY: 0.15,
    values: [13, 14],
  },
  {
    x: 6,
    y: 2,
    offsetX: 0.15,
    offsetY: 0.15,
    values: [13, 14, 16, 17],
  },
  {
    x: 6.5,
    y: 2,
    offsetX: 0.35,
    offsetY: 0.15,
    values: [16, 17],
  },
  {
    x: 7,
    y: 2,
    offsetX: 0.15,
    offsetY: 0.15,
    values: [16, 17, 19, 20],
  },
  {
    x: 7.5,
    y: 2,
    offsetX: 0.35,
    offsetY: 0.15,
    values: [19, 20],
  },
  {
    x: 8,
    y: 2,
    offsetX: 0.15,
    offsetY: 0.15,
    values: [19, 20, 22, 23],
  },
  {
    x: 8.5,
    y: 2,
    offsetX: 0.35,
    offsetY: 0.15,
    values: [22, 23],
  },
  {
    x: 9,
    y: 2,
    offsetX: 0.15,
    offsetY: 0.15,
    values: [22, 23, 25, 26],
  },
  {
    x: 9.5,
    y: 2,
    offsetX: 0.35,
    offsetY: 0.15,
    values: [25, 26],
  },
  {
    x: 10,
    y: 2,
    offsetX: 0.15,
    offsetY: 0.15,
    values: [25, 26, 28, 29],
  },
  {
    x: 10.5,
    y: 2,
    offsetX: 0.35,
    offsetY: 0.15,
    values: [28, 29],
  },
  {
    x: 11,
    y: 2,
    offsetX: 0.15,
    offsetY: 0.15,
    values: [28, 29, 31, 32],
  },
  {
    x: 11.5,
    y: 2,
    offsetX: 0.35,
    offsetY: 0.15,
    values: [31, 32],
  },
  {
    x: 12,
    y: 2,
    offsetX: 0.15,
    offsetY: 0.15,
    values: [31, 32, 34, 35],
  },
  {
    x: 12.5,
    y: 2,
    offsetX: 0.5,
    offsetY: 0.15,
    values: [34, 35],
  },
  {
    x: 1,
    y: 2.5,
    offsetX: 0.15,
    offsetY: 0.35,
    values: [0, 1],
  },
  {
    x: 2,
    y: 2.5,
    offsetX: 0.15,
    offsetY: 0.35,
    values: [1, 4],
  },
  {
    x: 3,
    y: 2.5,
    offsetX: 0.15,
    offsetY: 0.35,
    values: [4, 7],
  },
  {
    x: 4,
    y: 2.5,
    offsetX: 0.15,
    offsetY: 0.35,
    values: [7, 10],
  },
  {
    x: 5,
    y: 2.5,
    offsetX: 0.15,
    offsetY: 0.35,
    values: [10, 13],
  },
  {
    x: 6,
    y: 2.5,
    offsetX: 0.15,
    offsetY: 0.35,
    values: [13, 16],
  },
  {
    x: 7,
    y: 2.5,
    offsetX: 0.15,
    offsetY: 0.35,
    values: [16, 19],
  },
  {
    x: 8,
    y: 2.5,
    offsetX: 0.15,
    offsetY: 0.35,
    values: [19, 22],
  },
  {
    x: 9,
    y: 2.5,
    offsetX: 0.15,
    offsetY: 0.35,
    values: [22, 25],
  },
  {
    x: 10,
    y: 2.5,
    offsetX: 0.15,
    offsetY: 0.35,
    values: [25, 28],
  },
  {
    x: 11,
    y: 2.5,
    offsetX: 0.15,
    offsetY: 0.35,
    values: [28, 31],
  },
  {
    x: 12,
    y: 2.5,
    offsetX: 0.15,
    offsetY: 0.35,
    values: [31, 34],
  },
  {
    x: 1,
    y: 3,
    offsetX: 0.15,
    offsetY: 0.15,
    values: [0, 1, 2, 3],
  },
  {
    x: 1.5,
    y: 3,
    offsetX: 0.35,
    offsetY: 0.15,
    values: [1, 2, 3],
  },
  {
    x: 2,
    y: 3,
    offsetX: 0.15,
    offsetY: 0.15,
    values: [1, 2, 3, 4, 5, 6],
  },
  {
    x: 2.5,
    y: 3,
    offsetX: 0.35,
    offsetY: 0.15,
    values: [4, 5, 6],
  },
  {
    x: 3,
    y: 3,
    offsetX: 0.15,
    offsetY: 0.15,
    values: [4, 5, 6, 7, 8, 9],
  },
  {
    x: 3.5,
    y: 3,
    offsetX: 0.35,
    offsetY: 0.15,
    values: [7, 8, 9],
  },
  {
    x: 4,
    y: 3,
    offsetX: 0.15,
    offsetY: 0.15,
    values: [7, 8, 9, 10, 11, 12],
  },
  {
    x: 4.5,
    y: 3,
    offsetX: 0.35,
    offsetY: 0.15,
    values: [10, 11, 12],
  },
  {
    x: 5,
    y: 3,
    offsetX: 0.15,
    offsetY: 0.15,
    values: [10, 11, 12, 13, 14, 15],
  },
  {
    x: 5.5,
    y: 3,
    offsetX: 0.35,
    offsetY: 0.15,
    values: [13, 14, 15],
  },
  {
    x: 6,
    y: 3,
    offsetX: 0.15,
    offsetY: 0.15,
    values: [13, 14, 15, 16, 17, 18],
  },
  {
    x: 6.5,
    y: 3,
    offsetX: 0.35,
    offsetY: 0.15,
    values: [16, 17, 18],
  },
  {
    x: 7,
    y: 3,
    offsetX: 0.15,
    offsetY: 0.15,
    values: [16, 17, 18, 19, 20, 21],
  },
  {
    x: 7.5,
    y: 3,
    offsetX: 0.35,
    offsetY: 0.15,
    values: [19, 20, 21],
  },
  {
    x: 8,
    y: 3,
    offsetX: 0.15,
    offsetY: 0.15,
    values: [19, 20, 21, 22, 23, 24],
  },
  {
    x: 8.5,
    y: 3,
    offsetX: 0.35,
    offsetY: 0.15,
    values: [22, 23, 24],
  },
  {
    x: 9,
    y: 3,
    offsetX: 0.15,
    offsetY: 0.15,
    values: [22, 23, 24, 25, 26, 27],
  },
  {
    x: 9.5,
    y: 3,
    offsetX: 0.35,
    offsetY: 0.15,
    values: [25, 26, 27],
  },
  {
    x: 10,
    y: 3,
    offsetX: 0.15,
    offsetY: 0.15,
    values: [25, 26, 27, 28, 29, 30],
  },
  {
    x: 10.5,
    y: 3,
    offsetX: 0.35,
    offsetY: 0.15,
    values: [28, 29, 30],
  },
  {
    x: 11,
    y: 3,
    offsetX: 0.15,
    offsetY: 0.15,
    values: [28, 29, 30, 31, 32, 33],
  },
  {
    x: 11.5,
    y: 3,
    offsetX: 0.35,
    offsetY: 0.15,
    values: [31, 32, 33],
  },
  {
    x: 12,
    y: 3,
    offsetX: 0.15,
    offsetY: 0.15,
    values: [31, 32, 33, 34, 35, 36],
  },
  {
    x: 12.5,
    y: 3,
    offsetX: 0.5,
    offsetY: 0.15,
    values: [34, 35, 36],
  },
  { x: 0.5, y: 1.5, offsetX: 0.5, offsetY: 1.5, values: [0] },
  { x: 1.5, y: 0.5, offsetX: 0.5, offsetY: 0.5, values: [3] },
  { x: 2.5, y: 0.5, offsetX: 0.5, offsetY: 0.5, values: [6] },
  { x: 3.5, y: 0.5, offsetX: 0.5, offsetY: 0.5, values: [9] },
  { x: 4.5, y: 0.5, offsetX: 0.5, offsetY: 0.5, values: [12] },
  { x: 5.5, y: 0.5, offsetX: 0.5, offsetY: 0.5, values: [15] },
  { x: 6.5, y: 0.5, offsetX: 0.5, offsetY: 0.5, values: [18] },
  { x: 7.5, y: 0.5, offsetX: 0.5, offsetY: 0.5, values: [21] },
  { x: 8.5, y: 0.5, offsetX: 0.5, offsetY: 0.5, values: [24] },
  { x: 9.5, y: 0.5, offsetX: 0.5, offsetY: 0.5, values: [27] },
  { x: 10.5, y: 0.5, offsetX: 0.5, offsetY: 0.5, values: [30] },
  { x: 11.5, y: 0.5, offsetX: 0.5, offsetY: 0.5, values: [33] },
  { x: 12.5, y: 0.5, offsetX: 0.5, offsetY: 0.5, values: [36] },
  { x: 1.5, y: 1.5, offsetX: 0.5, offsetY: 0.5, values: [2] },
  { x: 2.5, y: 1.5, offsetX: 0.5, offsetY: 0.5, values: [5] },
  { x: 3.5, y: 1.5, offsetX: 0.5, offsetY: 0.5, values: [8] },
  { x: 4.5, y: 1.5, offsetX: 0.5, offsetY: 0.5, values: [11] },
  { x: 5.5, y: 1.5, offsetX: 0.5, offsetY: 0.5, values: [14] },
  { x: 6.5, y: 1.5, offsetX: 0.5, offsetY: 0.5, values: [17] },
  { x: 7.5, y: 1.5, offsetX: 0.5, offsetY: 0.5, values: [20] },
  { x: 8.5, y: 1.5, offsetX: 0.5, offsetY: 0.5, values: [23] },
  { x: 9.5, y: 1.5, offsetX: 0.5, offsetY: 0.5, values: [26] },
  { x: 10.5, y: 1.5, offsetX: 0.5, offsetY: 0.5, values: [29] },
  { x: 11.5, y: 1.5, offsetX: 0.5, offsetY: 0.5, values: [32] },
  { x: 12.5, y: 1.5, offsetX: 0.5, offsetY: 0.5, values: [35] },
  { x: 1.5, y: 2.5, offsetX: 0.5, offsetY: 0.5, values: [1] },
  { x: 2.5, y: 2.5, offsetX: 0.5, offsetY: 0.5, values: [4] },
  { x: 3.5, y: 2.5, offsetX: 0.5, offsetY: 0.5, values: [7] },
  { x: 4.5, y: 2.5, offsetX: 0.5, offsetY: 0.5, values: [10] },
  { x: 5.5, y: 2.5, offsetX: 0.5, offsetY: 0.5, values: [13] },
  { x: 6.5, y: 2.5, offsetX: 0.5, offsetY: 0.5, values: [16] },
  { x: 7.5, y: 2.5, offsetX: 0.5, offsetY: 0.5, values: [19] },
  { x: 8.5, y: 2.5, offsetX: 0.5, offsetY: 0.5, values: [22] },
  { x: 9.5, y: 2.5, offsetX: 0.5, offsetY: 0.5, values: [25] },
  { x: 10.5, y: 2.5, offsetX: 0.5, offsetY: 0.5, values: [28] },
  { x: 11.5, y: 2.5, offsetX: 0.5, offsetY: 0.5, values: [31] },
  { x: 12.5, y: 2.5, offsetX: 0.5, offsetY: 0.5, values: [34] },
  {
    x: 13.5,
    y: 0.5,
    offsetX: 0.5,
    offsetY: 0.5,
    values: [3, 6, 9, 12, 15, 18, 21, 24, 27, 30, 33, 36],
  },
  {
    x: 13.5,
    y: 1.5,
    offsetX: 0.5,
    offsetY: 0.5,
    values: [2, 5, 8, 11, 14, 17, 20, 23, 26, 29, 32, 35],
  },
  {
    x: 13.5,
    y: 2.5,
    offsetX: 0.5,
    offsetY: 0.5,
    values: [1, 4, 7, 10, 13, 16, 19, 22, 25, 28, 31, 34],
  },
  {
    x: 3,
    y: 3.5,
    offsetX: 2,
    offsetY: 0.5,
    values: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
  },
  {
    x: 7,
    y: 3.5,
    offsetX: 2,
    offsetY: 0.5,
    values: [13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24],
  },
  {
    x: 11,
    y: 3.5,
    offsetX: 2,
    offsetY: 0.5,
    values: [25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36],
  },
  {
    x: 2,
    y: 4.5,
    offsetX: 1,
    offsetY: 0.5,
    values: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18],
  },
  {
    x: 4,
    y: 4.5,
    offsetX: 1,
    offsetY: 0.5,
    values: [2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32, 34, 36],
  },
  {
    x: 6,
    y: 4.5,
    offsetX: 1,
    offsetY: 0.5,
    values: [1, 3, 5, 7, 9, 12, 14, 16, 18, 19, 21, 23, 25, 27, 30, 32, 34, 36],
  },
  {
    x: 8,
    y: 4.5,
    offsetX: 1,
    offsetY: 0.5,
    values: [2, 4, 6, 8, 10, 11, 13, 15, 17, 20, 22, 24, 26, 28, 29, 31, 33, 35],
  },
  {
    x: 10,
    y: 4.5,
    offsetX: 1,
    offsetY: 0.5,
    values: [1, 3, 5, 7, 9, 11, 13, 15, 17, 19, 21, 23, 25, 27, 29, 31, 33, 35],
  },
  {
    x: 12,
    y: 4.5,
    offsetX: 1,
    offsetY: 0.5,
    values: [19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36],
  },
]
